import React from "react";
import propTypes from "prop-types";
import {Link} from "gatsby";
import { useStrapiAllSeriesData, useStrapiAllResourcesData, useStrapiTopicData } from "../../../hooks";

const Breadcrumb = ({pathname, background, customCurrentPage, ...rest}) => {
    const breadcrumbs = pathname.split("/");
    const length = breadcrumbs.length;
    const resourcesNodes = useStrapiAllResourcesData();
    const seriesNodes = useStrapiAllSeriesData();
    const topicNodes = useStrapiTopicData();
    const resourcesData = resourcesNodes?.allStrapiResource?.nodes;
    const seriesData = seriesNodes?.allStrapiSerie?.nodes;
    const topicsData = topicNodes?.allStrapiTopic?.nodes
    const resourcesSeriesData = [...resourcesData, ...seriesData, ...topicsData]
    const capitalize = page =>{
        var capitalizedString = "";
        let resourceBreadcrumbText = resourcesSeriesData.filter(resource=>resource.slug === page);
        if(resourceBreadcrumbText.length > 0){
            let breadcrumbContent = resourceBreadcrumbText[0]?.card_title ?? resourceBreadcrumbText[0]?.title;
            capitalizedString = breadcrumbContent?.length > 35 ? breadcrumbContent.substring(0,35) + "..." : breadcrumbContent;
        } else {      
        const lowercaseString = page.replace(/-/g, " ");
        const wordsArray = lowercaseString.split(" ");
        
        for(let i=0; i<=wordsArray.length-1; i++){
            if(i === wordsArray.length-1){
                capitalizedString= capitalizedString.concat(wordsArray[i].charAt(0).toUpperCase().concat(wordsArray[i].substring(1)));
            } else{
                capitalizedString = capitalizedString.concat(wordsArray[i].charAt(0).toUpperCase().concat(wordsArray[i].substring(1)) + " ");
            }
        }
        
        if(capitalizedString === "Topics"){
            capitalizedString="Explore Topics"
        }
        if(capitalizedString === "Technical"){
            capitalizedString="Technical Assistance"
        }
        if(capitalizedString === "Toolkit"){
            capitalizedString="Child Welfare Training Toolkit"
        }
        if(capitalizedString === "Bibliography"){
            capitalizedString="Interactive Bibliography Search"
        }
        if(capitalizedString === "Videos And Webinars"){
            capitalizedString="Videos and Webinars"
        }
        if(capitalizedString === "Child Welfare Statistics"){
            capitalizedString="Child Welfare and Substance Use Disorder Treatment Statistics".substring(0,29) + "..."
        }
        if(capitalizedString === "Rpg"){
            capitalizedString="Regional Partnership Grant Program"
        }
        if(capitalizedString === "Idta"){
            capitalizedString="In-Depth Technical Assistance"
        }
        if(capitalizedString === "Whats New"){
            capitalizedString="What’s New on NCSACW"
        }
    }
        return capitalizedString;
    }
    const createLink = (breadcrumbs, breadcrumbItems)=>{
        let path="";
        for(let i=0; i<=breadcrumbItems-1; i++){
            breadcrumbs[i] !== "" && (path=path.concat("/" + breadcrumbs[i]));
        }
    return path;
    }

    return (
        <nav className={`usa-breadcrumb ${background} ${rest.wrapBreadcrumb && "usa-breadcrumb--wrap"}`} aria-label="Breadcrumbs">
            <ol className="usa-breadcrumb__list">
                {breadcrumbs.map((breadcrumb, idx)=>{
                    const breadcrumbItems = idx + 1;
                    if(breadcrumbItems=== 1 && breadcrumb === ""){
                        return (
                            <li key={`breadcrumb-item-${breadcrumbItems}`} className="usa-breadcrumb__list-item">
                                <Link to="/" className="usa-breadcrumb__link">
                                    <span>
                                        Home
                                    </span>
                                </Link>
                            </li>
                        )
                    } else if(breadcrumbItems === length-1){
                        return (
                            <li key={`breadcrumb-item-${breadcrumbItems}`} className="usa-breadcrumb__list-item usa-current" aria-current="page">
                                <span className="breadcrub-current-item">
                                    {customCurrentPage ? customCurrentPage : capitalize(breadcrumb)}
                                </span>
                            </li>
                        )
                    } else if(breadcrumbItems > 1 && breadcrumb === ""){
                        return;
                    } else{
                        return (
                            <li key={`breadcrumb-item-${breadcrumbItems}`} className="usa-breadcrumb__list-item">
                              <Link to={createLink(breadcrumbs, breadcrumbItems)}
                                className="usa-breadcrumb__link">
                                    <span>
                                    {capitalize(breadcrumb)}
                                    </span>
                                </Link>
                            </li>
                        )
                    }
                })}
            </ol>
        </nav>
    )
}
Breadcrumb.propTypes = {
    background: propTypes.oneOfType([propTypes.string]),
    wrapBreadcrumb: propTypes.oneOf([true, false]),
}
Breadcrumb.defaultProps = {
    background: "transparent-bg",
    wrapBreadcrumb: true,
}

export default Breadcrumb;

